// R4a implementer — CardSurface 모듈 (GREEN).
//
// 카드 surface primitive — 다크 카드 톤 wrapper 1개. R1 토큰만 사용 (hex 0건).
// 옵션 a + 옵션 1b (사용자 결정 2026-05-07): 단일 모듈 + theme prop +
// className 병합 + ...rest HTML 속성 패스스루.
//
// 책임 분리:
//   - CardSurface = surface 톤만 담당 (data-theme + 카드 배경/보더/라운드)
//   - host (KpiIndicatorCard / DashboardStatCard) = onClick / role / tabIndex /
//     data-testid 책임. host 가 props 로 전달 → wrapper <div> 에 패스스루.
//
// 외부 의존 0 (react-router-dom / 차트 / api / PageShell / DashboardPanel
// 직접 import 금지).

import React from 'react';
import './CardSurface.css';

const CardSurface = ({
  theme = 'dark',
  className = '',
  children,
  ...rest
}) => {
  const mergedClassName = className
    ? `card-surface ${className}`
    : 'card-surface';
  return (
    <div data-theme={theme} className={mergedClassName} {...rest}>
      {children}
    </div>
  );
};

export default CardSurface;
